<section class="template-card" [class.summary-question]="cardTemplate?.instruction" [class.for_sprint]="isSmartSprintUrl">
    <div class="card_info_example_preview" [ngStyle]="{'font-size': getCardInfoFontSize()}">
        Уровень {{ currentBoxLevel.level }}
        <span *ngIf="lessonDate" [ngStyle]="{'margin-left': getCardInforMargin()}">
            {{ lessonDate|date:'dd.MM.yyyy' }}
        </span>
    </div>
    <div *ngIf="cardTemplate?.instruction" class="instruction" [class.template-card__question]="!isSmartSprintUrl">
        {{ cardTemplate.instruction }}
    </div>
    <div class="exercise_example_preview" [ngStyle]="{'font-size': getFont(cardFormat)}">
        <div *ngFor="let exercise of cardTemplate.exercises; let i=index" style="text-align: left">
            <app-exercise-preview-calculation *ngIf="exercise.type == calculation || exercise.type == insert" [card_format]="cardFormat"
                [exercise]="exercise" [index]="i" [mainCardView]="mainCardView">
            </app-exercise-preview-calculation>
            <app-exercise-preview-task *ngIf="exercise.type == task || exercise.type == logic"
                [card_format]="cardFormat" [character]="character" [exercise]="exercise" [index]="i"
                [mainCardView]="mainCardView">
            </app-exercise-preview-task>
            <app-exercise-preview-magicbox *ngIf="exercise.type == magic_box && mb_body" [mb_body]="mb_body"
                [card_format]="cardFormat" [mainCardView]="mainCardView">
            </app-exercise-preview-magicbox>
            <app-exercise-preview-sequence *ngIf="exercise.type == sequence" [card_format]="cardFormat"
                [exercise]="exercise" [index]="i" [mainCardView]="mainCardView">
            </app-exercise-preview-sequence>
            <app-exercise-puzzle *ngIf="[puzzle_example, puzzle_task].includes(exercise.type)"
                [cardInstruction]="cardTemplate.instruction"
                [cardFormat]="cardFormat"
                [exercise]="exercise" [index]="i" [viewType]="'template'">
            </app-exercise-puzzle>
        </div>
    </div>
    <div class="charcter_example_preview" *ngIf="character && character.black_image">
        <img src="{{ main_domain }}{{ character.black_image_url }}" height="50%" [ngStyle]="{'width': getImageWidth()}"
            [alt]="character.title">
    </div>
</section>